import { Component } from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { scroller } from 'react-scroll/modules'
import { Formik } from '@src/types/BriefSearch/formikProps'

interface HOCProps {
  formik: Formik
}

class ScrollToFirstError extends Component<{} & HOCProps> {
  public componentDidUpdate(prevProps: HOCProps) {
    const { isSubmitting, isValidating, errors } = prevProps.formik
    const keys = Object.keys(errors)
    if (keys.length > 0 && isSubmitting && !isValidating) {
      scroller.scrollTo(keys[0], {
        duration: 800,
        smooth: true,
        isDynamic: true,
        offset: -150
      })
    }
  }

  public render = () => null
}

export const ScrollToError = compose(connect)(ScrollToFirstError)
